// 密码复杂度规则（与后端 PasswordPolicy、desktop-web passwordValidator 保持一致）：
// 长度 8-16；必须同时包含 英文字母（不分大小写）、数字、特殊字符 三类；且只允许这三类字符。
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 16;

// 允许的特殊字符集合（与后端 PasswordPolicy.SPECIAL_CHARS 一致）
const SPECIAL_CHARS = "!@#$%^&*()-_=+[]{};:'\",.<>/?\\|`~";

export interface PasswordChecks {
  // 长度是否满足 8-16
  lengthOk: boolean;
  // 是否同时包含字母+数字+特殊，且不含非法字符
  complexityOk: boolean;
}

export const checkPassword = (password: string | null | undefined): PasswordChecks => {
  const value = password ?? '';
  const lengthOk = value.length >= PASSWORD_MIN_LENGTH && value.length <= PASSWORD_MAX_LENGTH;

  let hasLetter = false;
  let hasDigit = false;
  let hasSpecial = false;
  let hasInvalid = false;
  for (const c of value) {
    if ((c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z')) {
      hasLetter = true;
    } else if (c >= '0' && c <= '9') {
      hasDigit = true;
    } else if (SPECIAL_CHARS.includes(c)) {
      hasSpecial = true;
    } else {
      hasInvalid = true;
    }
  }
  const complexityOk = hasLetter && hasDigit && hasSpecial && !hasInvalid;
  return { lengthOk, complexityOk };
};

export const isValidPassword = (password: string | null | undefined): boolean => {
  const { lengthOk, complexityOk } = checkPassword(password);
  return lengthOk && complexityOk;
};
